<template>
  <div class="bg-white">
    <div class="header-no-vehicle-app-image" v-if="noVehicleAppImage">
      <img :src="noVehicleAppImage" class="header-logo" />
    </div>
    <div class="header" v-else>
      <img src="/assets/icons/header-logo.svg" class="header-logo" />
    </div>
    <div class="q-px-lg q-py-sm">
      <MainHeadline v-if="message" align="center" :header="message" body="" />
      <MainHeadline
        v-else
        align="center"
        header="No vehicle application found"
        body="It looks like you don't have an active vehicle application in our system."
      />
    </div>
    <div class="q-px-lg q-py-sm">
      <ContactUs />
    </div>
  </div>
</template>

<script>
import ContactUs from '../../components/Atoms/ContactUs';
import MainHeadline from '../../components/Atoms/MainHeadline';
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: { ContactUs, MainHeadline },
  computed: {
    ...mapGetters({
      orgProfile: 'theme/getScoreboard'
    }),
    noVehicleAppImage() {
      return this.orgProfile && this.orgProfile.noVehicleAppImage;
    }
  },
  props: ['message']
};
</script>

<style lang="sass" scoped>
hr
  border: 0;
  border-top: 1px solid #EEEEEE;
.header
  padding: 50px 0 98px;
  text-align: center;
  background-color: #E9F3FE;
  background-image: url('/assets/icons/header-background.svg');
  background-position: center top;
  background-repeat: no-repeat;
</style>
